import { render, staticRenderFns } from "./wzc-option.vue?vue&type=template&id=2d6c939d&scoped=true&"
import script from "./wzc-option.vue?vue&type=script&lang=js&"
export * from "./wzc-option.vue?vue&type=script&lang=js&"
import style0 from "./wzc-option.vue?vue&type=style&index=0&id=2d6c939d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c939d",
  null
  
)

export default component.exports